<div class="table-main-container">
  <div #tableBox class="table-box">
    <nz-table class="records-list-table" #tableOfRecords [nzData]="listOfRecords.table.rowsArray"
      nzShowQuickJumper="true" [nzFrontPagination]="false" [nzLoading]="isLoading" nzSize="small" [nzBordered]="true">
      <!--[nzScroll]="{ y: (tableBox.offsetHeight - 210) + 'px' }"-->
      <thead>
        <tr>
          <th *ngIf="allowEditable" [nzLeft]="true" class="checkbox-column">
            <label nz-checkbox [(ngModel)]="allSelected" (ngModelChange)="selectAll($event)"
              class="checkbox-header"></label>
          </th>
          <th *ngIf="showCheckBoxInTableMode"></th>

          <ng-container *ngFor="let field of this.fields; let i = index">
            <th [nzSortFn]="[7].includes(field.DataType) ? undefined : true"
              [ngClass]="'data-type-' + field.DataType + ' table-cell-' + field.PropertyName"
              [nzSortDirections]="['ascend', 'descend']" [nzSortOrder]="
                [7].includes(field.DataType)
                  ? undefined
                  : i + 1 === sortedByField
                  ? sortedByDir.toLowerCase() + 'end'
                  : ''
              " (nzSortOrderChange)="changeSorting(i + 1, $event)" *ngIf="
                field.FieldName !== keyName &&
                field.AdditionalInformationParsed.VisibleInTableList &&
                ((fromDraft && field.AdditionalInformationParsed.FilterableInDraft) || !fromDraft)
              ">
              {{ field.Label | locale }}
            </th>
          </ng-container>
          <th *ngIf="
              ((moduleActions !== undefined && moduleActions.length > 0 ) ||
                moduleInformation.AuthorisedForCreate) &&
              inModuleList &&
              selectedRecordsFromCheckBox.length === 0
            " style="width: 36px"> {{ 'Action' | locale }} </th>
        </tr>
        <tr class="filter-row">
          <th *ngIf="allowEditable" [nzLeft]="true" class="checkbox-column">

          </th>


          <th *ngIf="showCheckBoxInTableMode"></th>
          <ng-container *ngFor="let field of this.fields; let i = index">
            <th *ngIf="
                field.FieldName !== keyName &&
                field.AdditionalInformationParsed.VisibleInTableList &&
                ((fromDraft && field.AdditionalInformationParsed.FilterableInDraft) || !fromDraft)
              " [style.width.px]="
                field.AdditionalInformationParsed.Width !== 0
                  ? field.AdditionalInformationParsed.Width
                  : null
              ">
              <div *ngIf="field.DataType === FieldDataType.Date" class="range-date">
                <nz-space nzDirection="vertical">
                  <nz-space-item>
                    <nz-date-picker [nzDateRender]="tplRender" [(ngModel)]="filters[field.PropertyName].valueFrom"
                      (ngModelChange)="
                        filters[field.PropertyName].filterType = 2;

                        updateFilter()
                      " [nzFormat]="global.companyConfiguration.DateFormat" [nzPlaceHolder]="'From' | locale"
                      [nzSize]="'small'">
                    </nz-date-picker>
                  </nz-space-item>
                  <nz-space-item>
                    <nz-date-picker [nzDateRender]="tplRender" [(ngModel)]="filters[field.PropertyName].valueTo"
                      (ngModelChange)="
                        filters[field.PropertyName].filterType = 2;

                        updateFilter()
                      " [nzFormat]="global.companyConfiguration.DateFormat" [nzPlaceHolder]="'To' | locale"
                      [nzSize]="'small'">
                    </nz-date-picker>
                  </nz-space-item>
                </nz-space>
                <ng-template #tplRender let-current>
                  <div class="ant-picker-cell-inner" [class.border]="current.getDate() === 1">
                    {{ current.getDate() }}
                  </div>
                </ng-template>
              </div>
              <div *ngIf="
                  field.DataType === FieldDataType.String ||
                  field.DataType === FieldDataType.Paragraph ||
                  field.DataType === FieldDataType.Text ||
                  field.DataType === FieldDataType.Hidden ||
                  field.DataType === FieldDataType.Link
                ">
                <input nz-input [(ngModel)]="filters[field.PropertyName].singleValue" (ngModelChange)="
                    filters[field.PropertyName].filterType = 4;
                  " (keyup)="keyup($event)" [nzSize]="'small'" />
              </div>
              <div *ngIf="field.DataType === FieldDataType.Select">
                <nz-select nzShowSearch (nzOpenChange)="getOptions(field)" nzAllowClear
                  [(ngModel)]="filters[field.PropertyName].singleValue" (ngModelChange)="
                    filters[field.PropertyName].filterType = 4; updateFilter()
                  " [nzSize]="'small'">
                  <ng-container *ngFor="let option of field.Options">
                    <nz-option *ngIf="!isLoading" [nzValue]="
                        option.DBValue != null && option.DBValue !== undefined
                          ? option.DBValue.toString()
                          : option.Code.toString()
                      " [nzLabel]="
                        field.AdditionalInformationParsed.OptionsToBeTranslated
                          ? (option.Name | locale)
                          : option.Name
                      ">
                    </nz-option>
                  </ng-container>
                  <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
                    <i nz-icon nzType="loading" class="loading-icon"></i>
                    {{ "Loading ..." | locale }}
                  </nz-option>
                </nz-select>
              </div>
              <div *ngIf="
                  [
                    FieldDataType.Number,
                    FieldDataType.Amount,
                    FieldDataType.AmountFromDocument,
                    FieldDataType.Integer,
                    FieldDataType.Percent,
                    FieldDataType.Price,
                    FieldDataType.PriceFromDocument,
                    FieldDataType.PriceLines,
                    FieldDataType.PriceLocalCurrency,
                    FieldDataType.PriceSystemCurrency,
                    FieldDataType.Quantity
                  ].indexOf(field.DataType) !== -1
                " class="range-number">
                <nz-space nzDirection="vertical">
                  <nz-space-item>
                    <nz-input-number [(ngModel)]="filters[field.PropertyName].valueFrom" (ngModelChange)="
                        filters[field.PropertyName].filterType = 1;
                      " [nzPlaceHolder]="'From' | locale" (keyup)="keyup($event)" [nzSize]="'small'"></nz-input-number>
                  </nz-space-item>
                  <nz-space-item>
                    <nz-input-number [(ngModel)]="filters[field.PropertyName].valueTo" (ngModelChange)="
                        filters[field.PropertyName].filterType = 1;
                      " (keyup)="keyup($event)" [nzPlaceHolder]="'To' | locale" [nzSize]="'small'"></nz-input-number>
                  </nz-space-item>
                </nz-space>
              </div>
            </th>
          </ng-container>
          <th *ngIf="
              ((moduleActions !== undefined && moduleActions.length > 0 ) ||
                moduleInformation.AuthorisedForCreate) &&
              inModuleList &&
              selectedRecordsFromCheckBox.length === 0
            "></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of tableOfRecords.data"
          [class]="'table-row ' + (data['RowCustomClass'] != null && data['RowCustomClass'] !== undefined ? data['RowCustomClass'] : '')"
          [ngClass]="{
            'row-selected': inModuleList
              ? selectedRecordsFromCheckBox.indexOf(data[this.keyName]) != -1
              : selectedRecords.indexOf(data[this.keyName].toString()) != -1
              , 'row-not-selectable': !(data['U_ITM_ACTIVE'] == null || data['U_ITM_ACTIVE'] === undefined || data['U_ITM_ACTIVE'] === 'true')
          }">

          <td *ngIf="allowEditable" [nzLeft]="true" class="checkbox-column">
            <label nz-checkbox [(ngModel)]="data.selected" (ngModelChange)="checkboxChange(data)"
              class="checkbox-cell"></label>
          </td>

          <td [nzChecked]="
              inModuleList
                ? selectedRecordsFromCheckBox.indexOf(data[this.keyName]) != -1
                : selectedRecords.indexOf(data[this.keyName].toString()) != -1
            " (nzCheckedChange)="rowSelectedFromCheckBox(data, $event)" *ngIf="showCheckBoxInTableMode"
            [nzDisabled]="!(data['U_ITM_ACTIVE'] == null || data['U_ITM_ACTIVE'] === undefined || data['U_ITM_ACTIVE'] === 'true')">
          </td>


          <ng-container *ngFor="let field of this.fields">

            <td *ngIf="
                field.FieldName !== keyName &&
                field.AdditionalInformationParsed.VisibleInTableList &&
                ((fromDraft && field.AdditionalInformationParsed.FilterableInDraft) || !fromDraft)
              " [ngSwitch]="field.DataType" nzEllipsis="true"
              [ngClass]="'data-type-' + field.DataType + ' table-cell-' + field.PropertyName + ' table-cell-' + field.PropertyName + '-' + removeSpaces(data[field.FieldName])">
              <!-- String -->

              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <div class="editable-container" *ngSwitchCase="FieldDataType.String"
                [ngClass]="{'editable-field':field.AdditionalInformationParsed.EditableInList}"
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)">
                  <span [innerHTML]="data[field.FieldName] | safeHtml | nzEllipsis : 36 : '...'"
                    [title]="data[field.FieldName]">
                  </span>
                  <i *ngIf="field.AdditionalInformationParsed.EditableInList" nz-icon nzType="edit" nzTheme="outline" class="edit-icon">
                  </i>
                </div>
              </ng-container>


              <ng-container *ngSwitchCase="FieldDataType.String">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)="disableEdit(data, data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data, data[field.FieldName], field)" />
              </ng-container>



              <!-- Number  -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <div class="editable-container" *ngSwitchCase="FieldDataType.Number"
                  [ngClass]="{'editable-field':field.AdditionalInformationParsed.EditableInList}"
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)">
                  <span [innerHTML]="data[field.FieldName] | nzEllipsis : 36 : '...'" [title]="data[field.FieldName]">

                  </span>
                  <i *ngIf="field.AdditionalInformationParsed.EditableInList" nz-icon nzType="edit" nzTheme="outline"
                    class="edit-icon">
                  </i>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Number">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)="disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>
              <!-- Select -->

              <!-- <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <span (click)="true ? enableEdit(data, field) : rowSelected(data)" *ngSwitchCase="FieldDataType.Select"
                  [innerHTML]="data[field.FieldName] | nzEllipsis : 36 : '...'" [title]="data[field.FieldName]">
                </span>
              </ng-container> -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <div class="editable-container" *ngSwitchCase="FieldDataType.Select"
                  [ngClass]="{'editable-field':field.AdditionalInformationParsed.EditableInList}"
                   (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)">

                  <span [title]="getOptionLabel(field, data[field.FieldName])">
                    {{ getOptionLabel(field, data[field.FieldName]) | nzEllipsis : 36 : '...' }}

                  </span>
                  <i *ngIf="field.AdditionalInformationParsed.EditableInList" nz-icon nzType="edit" nzTheme="outline" class="edit-icon">
                  </i>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Select">
                <nz-select *ngIf="editingCells[getCellKey(data, field)] && field.DataType === FieldDataType.Select"
                  [(ngModel)]="data[field.FieldName]" (ngModelChange)="disableEdit(data,data[field.FieldName], field)"
                  (nzOpenChange)="getOptions(field)" nzAllowClear nzShowSearch>

                  <ng-container *ngFor="let option of field.Options">
                    <nz-option *ngIf="!isLoading" [nzValue]="
                        option.DBValue != null && option.DBValue !== undefined
                          ? option.DBValue.toString()
                          : option.Code.toString()
                      " [nzLabel]="
                        field.AdditionalInformationParsed.OptionsToBeTranslated
                          ? (option.Name | locale)
                          : option.Name
                      ">
                    </nz-option>
                  </ng-container>
                </nz-select>
              </ng-container>


              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.Link" [innerHTML]="data[field.FieldName]">
              </span>
              <!-- <div *ngSwitchCase="FieldDataType.Link">
                <a class="link-button" nz-button nzType="text" (click)="openRecordPage(field, data[field.FieldName])">
                  <i class="far fa-arrow-right"></i>
                </a>
                <span class="link-span" (click)="rowSelected(data)"
                  [innerHTML]="data[field.FieldName] | nzEllipsis: 36:'...'" [title]="data[field.FieldName]">
                </span>
              </div>-->



              <!-- Data -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <div class="editable-container" *ngSwitchCase="FieldDataType.Date"
                  [ngClass]="{'editable-field':field.AdditionalInformationParsed.EditableInList}"
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)">

                  <span [innerHTML]="
                  data[field.FieldName] | safeHtml | nzEllipsis : 36 : '...'
                " [title]="data[field.FieldName]">

                  </span>
                  <i *ngIf="field.AdditionalInformationParsed.EditableInList" nz-icon nzType="edit" nzTheme="outline"
                    class="edit-icon">
                  </i>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Date">
                <nz-date-picker *ngIf="editingCells[getCellKey(data, field)] && field.DataType === FieldDataType.Date"
                  [(ngModel)]="data[field.FieldName]" [nzFormat]="dateFormat"
                  (ngModelChange)="disableEdit(data,data[field.FieldName], field)"
                  class="editable-date-picker"></nz-date-picker>


              </ng-container>
              <!-- <span
                (click)="rowSelected(data)"
                *ngSwitchCase="FieldDataType.Time"
                [innerHTML]="data[field.FieldName] | nzEllipsis : 36 : '...'"
                [title]="data[field.FieldName]"
              >
              </span> -->
              <!-- Text -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <div class="editable-container" *ngSwitchCase="FieldDataType.Text"
                  [ngClass]="{'editable-field':field.AdditionalInformationParsed.EditableInList}"
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)">

                  <span [innerHTML]="data[field.FieldName] | nzEllipsis : 36 : '...'" [title]="data[field.FieldName]">
                  </span>
                  <i *ngIf="field.AdditionalInformationParsed.EditableInList" nz-icon nzType="edit" nzTheme="outline"
                    class="edit-icon">
                  </i>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Text">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)="disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>
              <!-- Price -->

              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <div class="editable-container" *ngSwitchCase="FieldDataType.Price"
                  [ngClass]="{'editable-field':field.AdditionalInformationParsed.EditableInList}"
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)">

                  <span
                    (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)"
                    *ngSwitchCase="FieldDataType.Price" [innerHTML]="data[field.FieldName] | amount : 'price'">
                  </span>

                  <i *ngIf="field.AdditionalInformationParsed.EditableInList" nz-icon nzType="edit" nzTheme="outline"
                    class="edit-icon">
                  </i>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="FieldDataType.Price">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)=" disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>
              <!-- Percent -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <div class="editable-container" *ngSwitchCase="FieldDataType.Percent"
                  [ngClass]="{'editable-field':field.AdditionalInformationParsed.EditableInList}"
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)">


                  <span [innerHTML]="data[field.FieldName] | amount : 'percent'">
                  </span>
                  <i *ngIf="field.AdditionalInformationParsed.EditableInList" nz-icon nzType="edit" nzTheme="outline"
                    class="edit-icon">
                  </i>
                </div>

              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Percent">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)=" disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>

              <span (click)="previewImage(data,field)" *ngSwitchCase="FieldDataType.Attachment"
                [innerHTML]="data[field.FieldName] | nzEllipsis : 36 : '...'" [title]="data[field.FieldName]">
              </span>
              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.Hidden"
                [innerHTML]="data[field.FieldName] | nzEllipsis : 36 : '...'" [title]="data[field.FieldName]">
              </span>
              <!-- Label -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <span
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)"
                  *ngSwitchCase="FieldDataType.Label" [innerHTML]="data[field.FieldName] | nzEllipsis : 36 : '...'"
                  [title]="data[field.FieldName]">
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Label">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)=" disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>
              <!-- Address -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <span
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)"
                  *ngSwitchCase="FieldDataType.Address" [innerHTML]="data[field.FieldName] | nzEllipsis : 36 : '...'"
                  [title]="data[field.FieldName]">
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Address">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)=" disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>

              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.PriceLocalCurrency"
                [innerHTML]="data[field.FieldName] | amount : 'price'">
              </span>
              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.PriceSystemCurrency"
                [innerHTML]="data[field.FieldName] | amount : 'price'">
              </span>
              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.PriceLines"
                [innerHTML]="data[field.FieldName] | amount : 'price'">
              </span>
              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.PriceFromDocument"
                [innerHTML]="data[field.FieldName] | amount : 'price'">
              </span>
              <span *ngSwitchCase="FieldDataType.Checkbox" [innerHTML]="data[field.FieldName]"
                [title]="data[field.FieldName]">
              </span>
              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.MultipleDate"
                [innerHTML]="data[field.FieldName]" [title]="data[field.FieldName]">
              </span>
              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.HTMLEditor"
                [innerHTML]="data[field.FieldName]" [title]="data[field.FieldName]">
              </span>
              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.CCValidity"
                [innerHTML]="data[field.FieldName]">
              </span>
              <!-- Property -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <span
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)"
                  *ngSwitchCase="FieldDataType.Property" [innerHTML]="data[field.FieldName]"
                  [title]="data[field.FieldName]">
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="FieldDataType.Property">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)="disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>
              <!-- Amount -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <span
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)"
                  *ngSwitchCase="FieldDataType.Amount" [innerHTML]="data[field.FieldName] | amount">
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Amount">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)="disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>

              <!-- Amount From Document -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <span
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)"
                  *ngSwitchCase="FieldDataType.AmountFromDocument" [innerHTML]="data[field.FieldName] | amount">
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.AmountFromDocument">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)="disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>


              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.ItemImage" [title]="data[field.FieldName]">
                <img style="width: 100px" [src]="
                    data[field.FieldName] === null ||
                    data[field.FieldName] === undefined ||
                    data[field.FieldName] === ''
                      ? 'assets/not-available.jpg'
                      : (data[field.FieldName] | productImageUrl)
                  " />
              </span>
              <!-- Quantity -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <div class="editable-container" *ngSwitchCase="FieldDataType.Quantity"
                  [ngClass]="{'editable-field':field.AdditionalInformationParsed.EditableInList}"
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)">

                  <span [innerHTML]="data[field.FieldName] | amount : 'quantity'">
                  </span>
                  <i *ngIf="field.AdditionalInformationParsed.EditableInList" nz-icon nzType="edit" nzTheme="outline"
                    class="edit-icon">
                  </i>
                </div>

              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Quantity">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)="disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>

              <!-- Title -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <span
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)"
                  *ngSwitchCase="FieldDataType.Title" [innerHTML]="data[field.FieldName] | nzEllipsis : 36 : '...'"
                  [title]="data[field.FieldName]">
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Title">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)="disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>


              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.Signature"
                [innerHTML]="data[field.FieldName]">
              </span>
              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.Icon" [innerHTML]="data[field.FieldName]">
              </span>
              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.Button"
                [innerHTML]="data[field.FieldName]">
              </span>
              <span (click)="rowSelected(data)" *ngSwitchCase="FieldDataType.Map" [innerHTML]="data[field.FieldName]">
              </span>

              <!-- Paragraph -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <span
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)"
                  *ngSwitchCase="FieldDataType.Paragraph" [innerHTML]="data[field.FieldName]">
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Paragraph">
                <input *ngIf="editingCells[getCellKey(data, field)]" nz-input [(ngModel)]="data[field.FieldName]"
                  (blur)="disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>

              <!-- Integer -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <span
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) :rowSelected(data)"
                  *ngSwitchCase="FieldDataType.Integer" [innerHTML]="data[field.FieldName]">
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Integer">
                <input type="number" *ngIf="editingCells[getCellKey(data, field)]" nz-input
                  [(ngModel)]="data[field.FieldName]" (blur)="disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>

              <!-- TimeAmount -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <span
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)"
                  *ngSwitchCase="FieldDataType.TimeAmount" [innerHTML]="data[field.FieldName] | amount : 'time'">
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.TimeAmount">
                <input type="number" *ngIf="editingCells[getCellKey(data, field)]" nz-input
                  [(ngModel)]="data[field.FieldName]" (blur)="disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>
              <!-- Time -->
              <ng-container *ngIf="!editingCells[getCellKey(data, field)]">
                <span
                  (click)="field.AdditionalInformationParsed.EditableInList ? enableEdit(data, field) : rowSelected(data)"
                  *ngSwitchCase="FieldDataType.Time" [innerHTML]="data[field.FieldName] | amount : 'time'">
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="FieldDataType.Time">
                <input type="number" *ngIf="editingCells[getCellKey(data, field)]" nz-input
                  [(ngModel)]="data[field.FieldName]" (blur)="disableEdit(data,data[field.FieldName], field)"
                  (keydown.enter)="disableEdit(data,data[field.FieldName], field)" />
              </ng-container>



              <span (click)="rowSelected(data)" *ngSwitchDefault [innerHTML]="data[field.FieldName]">
              </span>
            </td>
          </ng-container>


          <td *ngIf="
              ((moduleActions !== undefined && moduleActions.length > 0 ) ||
                moduleInformation.AuthorisedForCreate) &&
              inModuleList &&
              selectedRecordsFromCheckBox.length === 0
            " style="text-align: center">
            <app-actions [isTokenized]="false" [moduleId]="moduleStructure.module.Id" [actionType]="'Edit'"
              [recordId]="data[this.keyName].toString()" [fromDraft]="fromDraft" [moduleInformation]="moduleInformation"
              [moduleStructure]="moduleStructure" [actions]="moduleActions" [inList]="true"
              [inModuleList]="inModuleList" [displayMode]="'table'"
              [key]="data.DocNum">
            </app-actions>
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="listOfRecords.totals != null">
        <tr>
          <td>
            <span class="footer-title">
              {{ "&Sigma;" | locale }}
            </span>
          </td>
          <td *ngFor="let field of this.fields; let i = index" [nzLeft]="i == 0">
            <span *ngIf="listOfRecords?.totals[field.FieldName] != null">
              {{ listOfRecords.totals[field.FieldName] | number }}
            </span>
          </td>
          <td></td>
        </tr>
      </tfoot>
    </nz-table>
  </div>
</div>







<div *ngIf="isLoadingDrawer" class="spin-overlay">
  <nz-spin [nzSpinning]="true" nzSimple nzSize="large"></nz-spin>
</div>
<!-- Bulk Edit -->
<nz-drawer [nzClosable]="false" [nzVisible]="visible" nzPlacement="right" nzTitle="Bulk Edit Fields"
  (nzOnClose)="closeDrawer()" [nzFooter]="footerTemplate" nzWrapClassName="confirmation-drawer drawer-size-3x"
  [nzClosable]="true">
  <ng-container *nzDrawerContent>
    <ng-container *ngFor="let field of fields; let i = index">
      <div style="margin-bottom: 16px;">
        <!-- Label -->
        <nz-row style="margin-bottom: 4px;" *ngIf="field.AdditionalInformationParsed.EditableInList === true">
          <nz-col [nzSpan]="24" style="font-weight: bold;">
            {{ field.Label | locale }}
          </nz-col>
        </nz-row>

        <!-- Inputs -->
        <nz-row>
          <nz-col [nzSpan]="24">

            <!-- Date Range -->
            <div *ngIf="field.DataType === FieldDataType.Date
            && field.AdditionalInformationParsed.EditableInList === true">
              <nz-space nzDirection="vertical" [nzSize]="8" style="width: 100%;">
                <nz-date-picker [nzDateRender]="tplRender" [nzFormat]="global.companyConfiguration.DateFormat"
                  [(ngModel)]="newValue[field.PropertyName]" (ngModelChange)="onFieldValueChange(field)"
                  [nzSize]="'small'" style="width: 100%;"></nz-date-picker>


              </nz-space>
            </div>

            <!-- Text/String -->
            <div *ngIf="[
                FieldDataType.String,
                FieldDataType.Paragraph,
                FieldDataType.Text,
                FieldDataType.Hidden,
                FieldDataType.Link
              ].includes(field.DataType)  && field.AdditionalInformationParsed.EditableInList === true">
              <input nz-input [nzSize]="'small'" style="width: 100%;" [(ngModel)]="newValue[field.PropertyName]"
                (ngModelChange)="onFieldValueChange(field)" />
            </div>

            <!-- Select -->
            <div *ngIf="field.DataType === FieldDataType.Select
            && field.AdditionalInformationParsed.EditableInList === true">
              <nz-select nzShowSearch (nzOpenChange)="getOptions(field)" nzAllowClear
                [(ngModel)]="newValue[field.PropertyName]" (ngModelChange)="onFieldValueChange(field)"
                [nzSize]="'small'" style="width: 100%;">
                <ng-container *ngFor="let option of field.Options">
                  <nz-option *ngIf="!isLoading"
                    [nzValue]="option.DBValue != null ? option.DBValue.toString() : option.Code.toString()" [nzLabel]="
                      field.AdditionalInformationParsed.OptionsToBeTranslated
                        ? (option.Name | locale)
                        : option.Name
                    "></nz-option>
                </ng-container>
                <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
                  <i nz-icon nzType="loading" class="loading-icon"></i>
                  {{ 'Loading ...' | locale }}
                </nz-option>
              </nz-select>
            </div>

            <!-- Number Range -->
            <div *ngIf="[
                FieldDataType.Number,
                FieldDataType.Amount,
                FieldDataType.AmountFromDocument,
                FieldDataType.Integer,
                FieldDataType.Percent,
                FieldDataType.Price,
                FieldDataType.PriceFromDocument,
                FieldDataType.PriceLines,
                FieldDataType.PriceLocalCurrency,
                FieldDataType.PriceSystemCurrency,
                FieldDataType.Quantity
              ].includes(field.DataType) && field.AdditionalInformationParsed.EditableInList === true">
              <nz-space nzDirection="vertical" [nzSize]="8" style="width: 100%;">
                <nz-input-number [(ngModel)]="newValue[field.PropertyName]" [nzSize]="'small'" style="width: 100%;"
                  [(ngModel)]="newValue[field.PropertyName]"
                  (ngModelChange)="onFieldValueChange(field)"></nz-input-number>

              </nz-space>
            </div>

          </nz-col>
        </nz-row>

        <!-- Template for Date Render -->
        <ng-template #tplRender let-current>
          <div class="ant-picker-cell-inner" [class.border]="current.getDate() === 1">
            {{ current.getDate() }}
          </div>
        </ng-template>
      </div>
    </ng-container>
  </ng-container>

  <!-- Footer -->
  <ng-template #footerTemplate>
    <nz-space>
      <nz-space-item>
        <button nz-button nzType="primary" (click)="submit()">
          <i nz-icon nzType="check-circle" nzTheme="outline"></i>
          {{ 'Apply' | locale }}
        </button>
      </nz-space-item>
      <nz-space-item>
        <button nz-button nzType="default" (click)="closeDrawer()">
          <i nz-icon nzType="close-circle" nzTheme="outline"></i>
          {{ 'Cancel' | locale }}
        </button>
      </nz-space-item>
    </nz-space>
  </ng-template>
</nz-drawer>
